export const convertPage = (p: string) => {
 if(isNaN(Number(p)) || Number(p) <= 1){
   return 0
 }

  return Number(p) - 1
}
